<template>
  <div id="userPlayer" ref="userPlayer">
    <b-row align-h="center" align-v="center" :class="userPlayerHeight" class="mt-md-5 mt-lg-5 mt-xl-5 mt-1">
      <b-col cols="12" class="text-center" v-if="$i18n.locale=='en' ">
        <h1>{{ title }}</h1>
        <h3>{{ subTitle }}</h3>
      </b-col>
      <b-col cols="12" class="text-center" v-if="$i18n.locale=='es' ">
        <h1>{{ titleEs }}</h1>
        <h3>{{ subTitleEs }}</h3>
      </b-col>
      <b-col cols="12" class="text-center" v-if="$i18n.locale=='cat'">
        <h1>{{ titleCat }}</h1>
        <h3>{{ subTitleCat }}</h3>
      </b-col>
      <b-col cols="10" sm="10" md="8" lg="8" xl="7" align-self="center"
             v-show="!goBack"
             :class="!isChatActivated? 'shadowPlayer pl-0 pr-0  mx-auto' : `${chatSmallDeviceActive} shadowPlayer pl-0 pr-0  mx-auto mx-sm-auto mx-md-auto ml-xl-5`">
        <b-row>
          <b-col v-if="isIframe && !isPosterEndImage" align-self="center">
            <b-embed v-if="$i18n.locale==='en'"
                     type="iframe"
                     aspect="16by9"
                     :src="playerUrl"
                     allowfullscreen
                     autoplay
            >
            </b-embed>
            <b-embed v-if="$i18n.locale==='es'"
                     autoplay
                     type="iframe"
                     aspect="16by9"
                     :src="playerUrlEs"
                     allowfullscreen>
            </b-embed>
            <b-embed v-if="$i18n.locale==='cat'"
                     autoplay
                     type="iframe"
                     aspect="16by9"
                     :src="playerUrlCat"
                     allowfullscreen>
            </b-embed>
          </b-col>
          <b-col v-if="!isIframe && !isPosterEndImage" align-self="center"
                 :class="!isChatActivated? 'mx-auto pl-0 pr-0' : `${chatSmallDeviceActive} shadowPlayer pl-0 pr-0  mx-auto mx-sm-auto mx-md-auto `">
            <b-img v-if="$i18n.locale==='en'" fluid-grow :src="posterStartEn"></b-img>
            <b-img v-if="$i18n.locale==='es'" fluid-grow :src="posterStartEs"></b-img>
            <b-img v-if="$i18n.locale==='cat'" fluid-grow :src="posterStartCat"></b-img>
          </b-col>
          <b-col v-if="!isIframe && isPosterEndImage" cols="12" align-self="start"
                 :class="!isChatActivated? 'mx-auto pl-0 pr-0' : `${chatSmallDeviceActive} shadowPlayer pl-0 pr-0  mx-auto mx-sm-auto `">
            <b-img v-if="$i18n.locale==='en'" fluid-grow :src="posterEndEn"></b-img>
            <b-img v-if="$i18n.locale==='es'" fluid-grow :src="posterEndEs"></b-img>
            <b-img v-if="$i18n.locale==='cat'" fluid-grow :src="posterEndCat"></b-img>
          </b-col>
        </b-row>

      </b-col>
      <b-col cols="6" md="3" v-if="isSmallDevice && isChatActivated" class="mt-sm-4 mb-sm-4">
        <b-row>
          <b-col v-on:click="activeChat" align-self="center">
            <b-button variant="light" class="chatIcon ">
              <b-icon-chat scale="3">
              </b-icon-chat>
            </b-button>
          </b-col>
          <b-col align-self="end">
            <a class="textSpeaker">{{ $t('playerMessageSendQuestion') }}</a>
          </b-col>
        </b-row>
      </b-col>
      <b-col v-if="isChatActivated && !isSmallDevice " cols="10" sm="10" md="10" class="mt-md-5 mt-sm-5" lg="10"
             xl="4" align-self="center">
        <b-card no-body>
          <b-card-header header-tag="nav">
            <b-nav card-header tabs>
              <b-nav-item class="navItem" :active="isGeneralActive" v-on:click="isGeneralActive = true">
                General
              </b-nav-item>
              <b-nav-item class="navItem" :active="!isGeneralActive"
                          v-on:click="isGeneralActive = false; coutNewPrivateMsg = 0">Private
                <b-badge>{{ coutNewPrivateMsg === 0 ? '' : coutNewPrivateMsg }}</b-badge>
              </b-nav-item>
            </b-nav>
          </b-card-header>

          <b-card-body class="text-center">
            <div id="conversation-panel" class="conversation-panel"
                 v-if="isGeneralActive">
              <div v-bind:style=" message.name === $t('playerMessageName') ? activeClass : ''"
                   class="message" v-for="(message, index) in newMessages" v-bind:key="index">
                <b>
                  {{ message.name }} ({{ message.company }})
                </b>
                <br>
                {{ message.msg }}
              </div>
            </div>
            <div class="conversation-panel"
                 v-if="!isGeneralActive">
              <div v-bind:style=" message.name === $t('playerMessageName') ? activeClass : ''"
                   class="message" v-for="(message, index) in privateMessages" v-bind:key="index">
                <b>
                  {{ message.name }}
                </b>
                <br>
                {{ message.msg }}
              </div>
            </div>
            <b-row align-h="end" v-if="isGeneralActive">
              <b-col cols="7" sm="8" md="8" lg="8" xl="9">
                <b-textarea v-model="messageSend.msg" v-on:keyup.enter="sendMessage">

                </b-textarea>
              </b-col>
              <b-col align-self="center" class="mt-md-2 mt-2 mt-lg-0 mt-xl-0" cols="4" sm="3" md="3"
                     lg="3" xl="3">
                <b-button variant="light" class="btnColor" v-on:click="sendMessage">
                  {{ $t('playerBtnSendMessage') }}
                </b-button>
              </b-col>

              <b-col v-if="!goBack" class="mt-2 text-center mr-5" cols="12">
                <a class="textSpeaker">{{ $t('playerMessageSendQuestion') }}</a>
              </b-col>
              <b-col cols="2" v-if="goBack" align-self="center">
                <b-icon-arrow90deg-left v-on:click="desactivateChat" style="cursor: pointer" id="tooltip-target-1"
                                        scale="1.5"></b-icon-arrow90deg-left>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-overlay :show="isLoading" no-wrap></b-overlay>
    <b-modal @hidden="verifyAnswerModal" id="modal-center" :title="questionTitle" hide-footer>
      <BaseTimer v-on:hideQuestionModal="timeOut" class="mx-auto" :TIME_LIMIT="timer*1"></BaseTimer>
      <b-row align-v="center" class="text-center mt-4" v-for="(item, index) in answers" v-bind:key="index">

        <b-col cols="12" lg="2">
          <label class=""> <b>{{ item.answerLetter }}</b></label>
        </b-col>
        <b-col cols="12" lg="10">
          <b-button style="font-size: 14px" v-on:click="sendResponse(item)"
          >
            {{ item.answer }}
          </b-button>

        </b-col>
      </b-row>

    </b-modal>
  </div>
</template>

<script>
import app from "../firebaseConfig/config";
import 'firebase/database'
import {mapState} from 'vuex'
import BaseTimer from "./BaseTimer";

export default {
  name: "UserChat",
  components: {
    BaseTimer
  },
  data: () => {
    return {
      chat: false,
      messageSend: {
        name: '',
        msg: '',
        date: '',
        email: '',
        company: '',
        filtered: false
      },
      newMessages: [],
      activeClass: 'background: #f5f5f5;',
      count: 0,
      isUpdated: false,
      numSameEmail: 0,
      userVerified: 0,
      title: '',
      subTitle: '',
      titleEs: '',
      subTitleEs: '',
      titleCat: '',
      subTitleCat: '',
      chatsRef: '',
      usersRef: '',
      isSmallDevice: false,
      userPlayerHeight: 'userPlayerHeight',
      chatSmallDeviceActive: '',
      goBack: false,
      privateMessages: [],
      isGeneralActive: true,
      code: '',
      coutNewPrivateMsg: 0,
      questionTitle: '',
      answers: [],
      whereToResponse: '',
      timer: '',
      timerInterval: null,
      userTimer: 0,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'right',
          align: 'center',
        },
        plugins: {
          labels: [
            {
              render: 'percentage',
              precision: 0,
              fontColor: '#fff',
              fontSize: 18,
              fontStyle: 'bold',
              shadowColor: 'black',
              showZero: true,
              textShadow: true,
            },
          ]
        }
      },
      answer: {question: [], total: []},
      isIframe: false,
      isPosterEndImage: false,
      isActivePanicPoster: false,
    }
  },
  computed: {
    ...mapState(['isChatActivated', 'playerUrl', 'playerUrlEs', 'playerUrlCat', 'isLoading', 'posterStartEn', 'posterStartEs', 'posterStartCat', 'posterEndEn', 'posterEndEs', 'posterEndCat', 'panicPoster'])
  },
  methods: {
    /**
     * Function that send question to realtime database
     */
    sendMessage() {
      //function to push message to firebase and if you are not admin inserts in chat
      const d = new Date;
      this.messageSend.date = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds()
      this.messageSend.date = this.messageSend.date.toString()
      this.messageSend.company = this.getCookie('userCompany')
      if (this.messageSend.msg[this.messageSend.msg.length - 1] === '\n') {
        this.messageSend.msg = this.messageSend.msg.slice(0, -1)
      }
      if (this.messageSend.msg.length >= 1 && this.messageSend.msg !== ' ') {
        /*this.newMessages.push({
          name: this.$i18n.t('playerMessageName'),
          msg: this.messageSend.msg,
          date: this.messageSend.date,
          company: this.messageSend.company
        })*/
        this.chatsRef.push(this.messageSend)
        this.messageSend.msg = ''
        this.messageSend.date = ''
        setTimeout(function () {
          const conversationPanel = document.getElementById('conversation-panel');
          conversationPanel.scrollTop = conversationPanel.clientHeight;
          conversationPanel.scrollTop = conversationPanel.scrollHeight - conversationPanel.scrollTop;
        }, 100)
      }
    },
    /**
     * Get cookie passed by param
     * @param cname
     * @returns {string}
     */
    getCookie(cname) {
      //function that passes the key of the cookie to obtain the value
      const name = cname + "=";
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },

    /**
     * Delete cookie passed by parm
     * @param name
     */
    deleteCookie(name) {
      document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },
    /**
     * Show chat in small devices
     */
    activeChat() {
      this.chatSmallDeviceActive = 'd-none'
      this.isSmallDevice = false;
      this.goBack = true;
      setTimeout(function () {
        const conversationPanel = document.getElementById('conversation-panel');
        conversationPanel.scrollTop = conversationPanel.clientHeight;
        conversationPanel.scrollTop = conversationPanel.scrollHeight - conversationPanel.scrollTop;
      }, 100)
    },
    /**
     * Hide chat in small devices
     */
    desactivateChat() {
      this.isSmallDevice = true;
      this.chatSmallDeviceActive = ''
      this.goBack = false;
    },
    /**
     * Recieve private msg form real time database
     */
    newPrivateMsg(snapshot) {
      const newPost = snapshot.val();
      this.privateMessages.push({
        name: newPost.name,
        email: newPost.email,
        msg: newPost.msg,
        date: newPost.date
      })
      this.coutNewPrivateMsg++;
      /*   this.$bvToast.toast(this.$i18n.t('userPlayerMessageArrived').toString(), {
             variant: 'info',
             solid: true
         })*/
    },
    /**
     * Recive questions form realtime database
     * @param snapshot
     */
    showQuestion(snapshot) {
      const question = snapshot.val()
      this.whereToResponse = question.response
      this.timer = question.timer
      this.userTimer = question.timer
      switch (this.$i18n.locale) {
        case 'en':
          this.questionTitle = question.en.queries
          this.answers = question.en.answers
          break;
        case 'es':
          this.questionTitle = question.es.question
          this.answers = question.es.answers
          break
        case 'cat' :
          this.questionTitle = question.cat.question
          this.answers = question.cat.answers
          break
      }
      this.deactivateFullscreen()
      this.timerInterval = setInterval(() => {
        this.userTimer -= 1
      }, 1000);
      this.$bvModal.show('modal-center')
    },
    /**
     * Response question hiven for webinar
     * @param item
     */
    sendResponse(item) {
      clearInterval(this.timerInterval)
      this.$bvModal.hide('modal-center')
      const answerRef = app.database().ref(`lallucana/${this.code}/answers/${this.whereToResponse}`)
      answerRef.push({option: `${item.answerLetter}`})
      this.answers.length = 0
      this.questionTitle = ''
      this.whereToResponse = ''
    },
    /**
     * Verify if user response or not
     */
    verifyAnswerModal() {
      if (this.questionTitle) {
        this.$bvModal.show('modal-center')
        this.timer = this.userTimer
      } else {
        this.$bvModal.hide('modal-center')
      }
    },
    /**
     *Deactivates fullscreen
     */
    deactivateFullscreen() {
      try {
        if (document.fullscreenElement) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        }
      } catch (e) {
        console.log(e.message)
      }
    },
    /**
     * Hide Modal when timer ends
     */
    timeOut() {
      clearInterval(this.timerInterval)
      this.$bvModal.hide('modal-center')
      this.answers.length = 0
      this.questionTitle = ''
      this.whereToResponse = ''
    },
    checkStatusIframe(snapshot) {
      snapshot.forEach((childSnapshot) => {
        const childData = childSnapshot.val();
        this.isIframe = childData
      });
    },
    checkStatusPosterEnd(snapshot) {
      snapshot.forEach((childSnapshot) => {
        const childData = childSnapshot.val();
        this.isPosterEndImage = childData
      });
    },
    /**
     * Check Panic Poster status when admin connects to manage event
     * @param snapshot
     * */
    checkStatusPanicPoster(snapshot) {
      snapshot.forEach((childSnapshot) => {
        const childData = childSnapshot.val();
        this.isActivePanicPoster = childData
      });
    },
    matchHeight() {
      try {
        if (document.documentElement.clientWidth <= 1200) {
          this.isSmallDevice = !this.goBack
          this.chatSmallDeviceActive = ''
        } else {
          this.chatSmallDeviceActive = ''
          this.isSmallDevice = false
          if (this.isChatActivated) {
            setTimeout(function () {
              const conversationPanel = document.getElementById('conversation-panel');
              conversationPanel.scrollTop = conversationPanel.clientHeight;
              conversationPanel.scrollTop = conversationPanel.scrollHeight - conversationPanel.scrollTop;
            }, 100)
          }
        }
        const totalComponentsHeight = this.$refs.userPlayer.clientHeight + 87 + 100
        document.documentElement.clientHeight <= 890 ? this.userPlayerHeight = 'min-vh-100' : this.userPlayerHeight = 'userPlayerHeight'
        if (totalComponentsHeight < document.documentElement.clientHeight) {
          if (this.footerClass !== 'footer') this.$store.commit('updateFooterClass', 'footer')
        } else {
          if (this.footerClass !== 'footerRelative') this.$store.commit('updateFooterClass', 'footerRelative')
        }
      } catch (e) {
        console.log(e.message)
      }


    },
  },
  created() {
    try {
      this.code = this.$route.params.id
      this.chatsRef = app.database().ref(`lallucana/${this.code}/msg`)
      this.usersRef = app.database().ref(`lallucana/${this.code}/users`)
      //deleteAdminCookie
      this.deleteCookie('adminUser')
      this.title = localStorage.getItem('webinarTitleEn')
      this.titleEs = localStorage.getItem('webinarTitleEs')
      this.titleCat = localStorage.getItem('webinarTitleCat')
      this.subTitle = localStorage.getItem('webinarSubTitle')
      this.subTitleEs = localStorage.getItem('webinarSubTitleEs')
      if (!this.playerUrl) this.$store.commit('updatePlayerUrl', localStorage.getItem('playerUrlEn'))
      if (!this.playerUrlEs) this.$store.commit('updatePlayerUrlEs', localStorage.getItem('playerUrlEs'))
      if (!this.playerUrlCat) this.$store.commit('updatePlayerUrlCat', localStorage.getItem('playerUrlCat'))
      if (!this.posterStartEn) this.$store.commit('updatePosterStartEn', localStorage.getItem('posterStartEn'))
      if (!this.posterEndEn) this.$store.commit('updatePosterEndEn', localStorage.getItem('posterEndEn'))
      if (!this.posterStartEs) this.$store.commit('updatePosterStartEs', localStorage.getItem('posterStartEs'))
      if (!this.posterEndEs) this.$store.commit('updatePosterEndEs', localStorage.getItem('posterEndEs'))
      if (!this.posterStartCat) this.$store.commit('updatePosterStartCat', localStorage.getItem('posterStartCat'))
      if (!this.posterEndCat) this.$store.commit('updatePosterEndCat', localStorage.getItem('posterEndCat'))
      this.messageSend.name = this.getCookie('name')
      this.messageSend.email = this.getCookie('email')
    } catch (e) {
        this.$router.push({path: '/'})
    }
    //Verify is cookie exist or not
    if (!document.cookie) {
      this.$router.push({path: '/'})
    } else {
      this.messageSend.name = this.getCookie('name')
      this.messageSend.email = this.getCookie('email')
    }
  },
  mounted() {
    this.matchHeight()
    window.addEventListener("resize", this.matchHeight);
    const regex = /[.,&·#$€\s]/g;
    const result = this.messageSend.email.replace(regex, '');
    this.myPrivateChatRef = app.database().ref(`lallucana/${this.code}/chat/${result}`)
    //function for receive the new messages added in firebase
    const newMessages = this.newMessages;
    this.chatsRef.on("child_added", (snapshot) => {
        const newPost = snapshot.val();
        newMessages.push({
          name: newPost.name,
          email: newPost.email,
          msg: newPost.msg,
          date: newPost.date,
          company: newPost.company,
          filtered: newPost.filtered
        })
        //There's a delay between firebase and user, that's why I execute this setTimeput
        setTimeout(() => {
          try {
            const conversationPanel = document.getElementById('conversation-panel');
            conversationPanel.scrollTop = conversationPanel.clientHeight;
            conversationPanel.scrollTop = conversationPanel.scrollHeight - conversationPanel.scrollTop;
          } catch (e) {
            console.log()
          }
        }, 200)
      })

    /**
     * Add listener in realtime database to recive private msg from secretary
     */
    this.myPrivateChatRef.on("child_added", this.newPrivateMsg)
    const questionRef = app.database().ref(`lallucana/${this.code}/questions`)
    questionRef.on('child_added', this.showQuestion)
    const iframeStatusRef = app.database().ref(`lallucana/${this.code}/iframeStatus`)
    const statusPosterRef = app.database().ref(`lallucana/${this.code}/posterEndStatus`)
    const statusPanicPosterRef = app.database().ref(`lallucana/${this.code}/panicPosterStatus`)
    iframeStatusRef.on('value', this.checkStatusIframe)
    statusPosterRef.on('value', this.checkStatusPosterEnd)
    statusPanicPosterRef.on('value', this.checkStatusPanicPoster)

  },
  destroyed() {
    window.removeEventListener("resize", this.matchHeight);
  }
}
</script>

<style scoped>
.conversation-panel {
  margin-bottom: 20px;
  text-align: left;
  max-height: 200px;
  overflow: auto;
  width: 100%;
}

.conversation-panel .message {
  border-bottom: 1px solid #E5E5E5;
  padding: 5px 10px;
}

hr {
  height: 1px;
  border: 0;
  background: #E5E5E5;
}

.shadowPlayer {
  box-shadow: 10px 10px 17px grey;
}

.userPlayerHeight {
  height: 82vh;
}

.navItem > a {
  color: black;
}

.chatIcon {
  background-color: transparent;
  border: transparent;
}

.chatIcon > span {
  background-color: transparent;
  border: transparent;
}
.btnColor {
    background-color: #a80d83;
    color: white;
}
</style>
